import { render, staticRenderFns } from "./InputAviso.vue?vue&type=template&id=879ce564&"
import script from "./InputAviso.vue?vue&type=script&lang=js&"
export * from "./InputAviso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports